export const de = {
    // App Entry
    app: {
      pageTitle: 'ForestHub | Fallklärung für Waldbesitzer',
      metaDescription: 'ForestHub hilft Waldbesitzern, Klarheit über ihre Situation zu gewinnen. Kostenloser Schnell-Check, ausführliche Fallklärung für 49 €.',
      headline: 'Ihr Arbeitsbereich',
      headlineDienstleister: 'Ihr Arbeitsbereich als Dienstleister',
      subheadline: 'Einordnung · Fallklärung · Nächster Schritt',
      description: 'ForestHub hilft Waldbesitzern, Klarheit über ihre Situation zu gewinnen – mit einer ehrlichen Einordnung und klaren nächsten Schritten.',
      hintLine: 'Neu bei ForestHub? Mehr Informationen finden Sie auf',
    },
    // AppShell
    appShell: {
      rolleWaldbesitzer: 'Waldbesitzer',
      rolleDienstleister: 'Dienstleister',
    },
    // Navigation
    nav: {
      dashboard: 'Dashboard',
      caseAnalysis: 'Fallanalyse',
      projects: 'Projekte',
      providers: 'Anbieter',
      myForest: 'Mein Wald',
      messages: 'Nachrichten',
      profile: 'Profil',
      settings: 'Einstellungen',
      login: 'Anmelden',
      register: 'Registrieren',
      logout: 'Abmelden',
      toWebsite: 'Zur Website',
      requestDemo: 'Situation beschreiben',
    },
    // Common
    common: {
      search: 'Suchen',
      filter: 'Filter',
      reset: 'Zurücksetzen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Weiter',
      submit: 'Absenden',
      loading: 'Laden...',
      noResults: 'Keine Ergebnisse',
      all: 'Alle',
      step: 'Schritt',
      fillAllFields: 'Bitte füllen Sie alle Felder aus',
    },
    // Landing
    landing: {
      connectedPlatforms: 'Verbundene Plattformen',
      projectBy: 'Ein Projekt von',
      contact: 'Kontakt',
      heroTagline: 'Für Menschen mit einem konkreten Wald- oder Forstfall',
      headerSlogan: 'Fälle ordnen. Punkte klären. Vorbereitet sein.',
      heroHeadline: 'Ihren Wald- oder Forstfall ordnen.',
      heroDesc: 'Beschreiben Sie kurz Ihre Situation. ForestHub hilft, offene Punkte, Stolpersteine und nächste Schritte sichtbar zu machen.',
      heroSubline: 'Erst ordnen. Dann handeln.',
      heroCta: 'Fall beschreiben – kostenlos',
      heroHint: 'Ohne Anmeldung · Ohne Verpflichtung · Erste Einordnung sofort',

      // TEIL A – Kernbotschaft
      blindeFleckenText: 'Viele Wald- und Forstfälle scheitern nicht am Wissen – sondern an übersehenen Punkten. ForestHub macht sichtbar, was leicht übersehen wird.',

      // TEIL B – Beispiele
      ueberseheneTitle: 'Typische Punkte, die oft übersehen werden:',
      uebersehen1: 'Teilflächen im Schutzgebiet',
      uebersehen2: 'Eingeschränkte Nutzungsmöglichkeiten',
      uebersehen3: 'Fehlende oder unklare Erschließung',
      uebersehen4: 'Wertrelevante Besonderheiten der Lage',
      trust1: 'Erste Einordnung in wenigen Minuten',
      trust2: 'Offene Punkte klar benannt',
      trust3: 'Kein Abo, keine versteckten Kosten',
      trust4: 'Sie zahlen nur, wenn Sie mehr Klarheit möchten',
      bridgeHint: 'Sie kommen von waldrechner.eu? Gut. Sie haben gerechnet. Jetzt ordnen wir Ihren Fall.',

      // TEIL A – Muster-Ergebnis Vorschau
      previewTitle: 'So sieht Ihre Einordnung aus',
      previewDesc: 'Sie erhalten eine klare Zusammenfassung Ihres Falls – mit Einschätzung, offenen Punkten und konkreten nächsten Schritten.',
      previewDesc2: 'Kein Fachgutachten. Aber eine solide Grundlage, mit der Sie zur Forststelle, zum Berater oder Käufer gehen können.',
      previewKurzfazit: 'Kurzfazit',
      previewKurzfazitText: 'Ihr Fall ist grundsätzlich machbar, aber es gibt offene Punkte, die vor dem nächsten Schritt geklärt werden sollten.',
      previewOffenePunkte: 'Offene Punkte',
      previewOP1: 'Eigentumsverhältnisse noch nicht vollständig geklärt',
      previewOP2: 'Genehmigungspflicht durch die zuständige Forststelle prüfen',
      previewStolpersteine: 'Stolpersteine',
      previewSS1: 'Naturschutzauflagen können den Zeitplan beeinflussen',
      previewSS2: 'Ohne Bewirtschaftungsvertrag kein Zugang zu Förderprogrammen',
      previewNaechsteSchritte: 'Nächste Schritte',
      previewNS1: 'Kontakt zur zuständigen Forststelle aufnehmen',
      previewNS2: 'Unterlagen zum Eigentumsnachweis zusammenstellen',
      previewHinweis: 'Dies ist ein Beispiel. Ihre Einordnung basiert auf Ihren konkreten Angaben.',

      // TEIL B – Vertrauensblock
      trustBlockTitle: 'Wer steckt dahinter?',
      trustBlockText1: 'ForestHub ist aus der praktischen Waldarbeit und aus echten Waldprojekten entstanden.',
      trustBlockText2: 'Es hilft, Waldfälle vorzuordnen, bevor Fachberatung oder Entscheidungen sinnvoll greifen.',
      trustBlockDaten: 'Ihre Angaben dienen ausschließlich der Einordnung Ihres Falls und werden nicht an Dritte weitergegeben.',

      // TEIL C – Kaufmoment Kontrast
      kaufKontrastTitle: 'Was bringt mir die Fallklärung zusätzlich?',
      kaufKontrastFree: 'Kostenlose Ersteinschätzung',
      kaufKontrastFreeF1: 'Erste Einordnung Ihres Falls',
      kaufKontrastFreeF2: 'Offene Punkte werden sichtbar',
      kaufKontrastFreeF3: 'Grobe Orientierung',
      kaufKontrastPaid: 'Fallklärung (49 €)',
      kaufKontrastPaidF1: 'Klar strukturierte Einordnung',
      kaufKontrastPaidF2: 'Nutzbar für Gespräche mit Forststelle, Berater oder Familie',
      kaufKontrastPaidF3: 'Mehr Sicherheit für den nächsten Schritt',
      kaufKontrastPaidF4: 'Als PDF zum Mitnehmen und Ausdrucken',
      howTitle: 'So funktioniert es',
      howSubtitle: 'Drei einfache Schritte – von der ersten Frage zur klaren Antwort.',
      howS1Title: 'Situation beschreiben',
      howS1Desc: 'Erzählen Sie in Ihren Worten, was Sie beschäftigt. Keine Formulare, keine Fachbegriffe nötig.',
      howS2Title: 'Einordnung und offene Punkte erkennen',
      howS2Desc: 'Sie sehen, was klar ist – und wo noch Unklarheiten oder Risiken bestehen können.',
      howS3Title: 'Nächsten Schritt kennen',
      howS3Desc: 'Sie erfahren, was jetzt sinnvoll ist – und was Sie gegebenenfalls noch extern klären sollten.',
      howCta: 'Jetzt kostenlos starten',
      tiersTitle: 'Klar und fair – so funktioniert ForestHub',
      tiersSubtitle: 'Zwei einfache Stufen. Keine versteckten Kosten. Sie entscheiden, wie weit Sie gehen.',
      tierATitle: 'Ersteinschätzung',
      tierAPrice: 'Kostenlos',
      tierABadge: 'Ohne Anmeldung',
      tierAF1: 'Beschreiben Sie Ihre Situation in eigenen Worten',
      tierAF2: 'Erkennen Sie offene Punkte und Stolpersteine',
      tierAF3: 'Erhalten Sie eine erste Einordnung',
      tierAF4: 'Sehen Sie, was als Nächstes wichtig ist',
      tierACta: 'Jetzt kostenlos starten',
      tierCTitle: 'Fallklärung',
      tierCPrice: '49 € pro Fall',
      tierCBadge: 'Einmalig pro Fall',
      tierCF1: 'Einordnung Ihres Falls aus mehreren Blickwinkeln',
      tierCF2: 'Offene Punkte, Stolpersteine und Risiken',
      tierCF3: 'Was der nächste sinnvolle Schritt ist',
      tierCF4: 'Was Sie zusätzlich extern klären sollten',
      tierCF5: 'Alles als PDF zum Ausdrucken und Mitnehmen',
      tierCCta: 'Fallklärung buchen – 49 €',
      tierDisclaimer: 'ForestHub ersetzt kein Gutachten und keine Rechts- oder Steuerberatung. Sie erhalten eine geordnete Einordnung Ihres Falls.',
      tierFollowTitle: 'Was Sie nicht bekommen',
      tierFollowDesc: 'Kein Gutachten. Keine rechtsverbindliche Bewertung. Keine Rechtsberatung. Keine Steuerberatung. Keine Expertenprüfung. Sie erhalten eine ehrliche Einordnung – nicht mehr, nicht weniger.',
      regTitle: 'Ab wann kostet es etwas?',
      regSubtitle: 'Die Ersteinschätzung ist kostenlos. Sie zahlen nur dann, wenn Sie eine ausführliche Fallklärung möchten.',
      regFreeTitle: 'Ersteinschätzung',
      regFreeDesc: 'Kostenlos und ohne Anmeldung. Beschreiben Sie Ihre Situation und erhalten Sie eine erste Einordnung mit offenen Punkten.',
      regLoginTitle: 'Fall speichern',
      regLoginDesc: 'Wenn Sie Ihren Fall sichern und später darauf zurückkommen möchten, können Sie sich kostenlos registrieren.',
      regPaidTitle: 'Fallklärung buchen',
      regPaidDesc: 'Für 49 € erhalten Sie eine ausführliche Einordnung mit Stolpersteinen, nächsten Schritten und einem PDF zum Mitnehmen. Kein Abo – Sie zahlen einmalig pro Fall.',
      posTitle: 'Erst ordnen, dann handeln',
      posSubtitle: 'Viele handeln zu früh. ForestHub hilft, zuerst eine erste Struktur zu gewinnen.',
      pos1Strike: 'Nicht: Sofort handeln',
      pos1Better: 'Sondern: Erst ordnen, was vorliegt',
      pos1Desc: 'Viele starten Maßnahmen, bevor sie ihre Situation richtig einschätzen können. ForestHub sorgt dafür, dass Sie vorbereitet sind.',
      pos2Strike: 'Nicht: Komplizierte Formulare ausfüllen',
      pos2Better: 'Sondern: In eigenen Worten beschreiben',
      pos2Desc: 'Keine 40 Felder. Erzählen Sie einfach, was Sie beschäftigt. ForestHub versteht Sie.',
      pos3Strike: 'Nicht: Ohne Orientierung entscheiden',
      pos3Better: 'Sondern: Offene Punkte und mögliche nächste Schritte kennen',
      pos3Desc: 'ForestHub zeigt Ihnen, wo Sie stehen und was als Nächstes sinnvoll sein könnte.',
      pos4Strike: 'Nicht: Teure Beratung blind buchen',
      pos4Better: 'Sondern: Zuerst ordnen, was wirklich offen ist',
      pos4Desc: 'Bevor Sie einen Gutachter oder Berater beauftragen, sollten Sie wissen, welche Punkte wirklich offen sind.',
      ownersLabel: 'Sie haben einen konkreten Fall',
      ownersTitle: 'Ihren Fall ordnen – einfach und verständlich',
      ownersF1: 'Beschreiben Sie Ihre Situation in Ihren Worten',
      ownersF2: 'Offene Punkte und Stolpersteine werden sichtbar',
      ownersF3: 'Mögliche nächste Schritte erkennen',
      ownersF4: 'Bei Bedarf eine ausführliche Fallklärung buchen',
      ownersCta: 'Jetzt Fall beschreiben',
      heirsLabel: 'Wald geerbt oder neu übernommen?',
      heirsTitle: 'Kein Vorwissen nötig – einfach starten',
      heirsF1: 'Sie wissen nicht weiter? Genau dafür ist ForestHub da.',
      heirsF2: 'Keine Fachbegriffe nötig – beschreiben Sie einfach, was Sie beschäftigt',
      heirsF3: 'Erfahren Sie, worauf Sie achten sollten',
      heirsF4: 'Sehen Sie, ob und wo Sie professionelle Hilfe brauchen',
      heirsCta: 'Jetzt Fall beschreiben',
      fuerWenTitle: 'Für wen ist ForestHub gedacht?',
      navProjekte: 'Meine Fälle',
      navDienstleister: 'Fallklärung',
      footerDesc: 'Strukturierte Vorordnung für Ihren Wald- oder Forstfall – sachlich, ehrlich und bezahlbar.',
      linksTitle: 'Links',
      schnellCheckLink: 'Fall beschreiben',
      startProject: 'Fallklärung',
      offerServices: 'Orientierung',
      forOwners: 'Für Wald- und Forstfälle',
      forProviders: 'Über ForestHub',
      // Wechselhilfe
      wechselTitle: 'Noch unsicher, wo Sie anfangen sollen?',
      wechselText: 'Wenn Sie zuerst eine Zahl prüfen oder Ihren Fall grob einordnen möchten, können Sie zu Waldrechner zurückkehren. Wenn Sie ForestHub erst verstehen möchten, finden Sie eine kurze Erklärung auf foresthub.app.',
      wechselWaldrechner: 'Zur Orientierung bei Waldrechner',
      wechselForesthub: 'ForestHub kurz erklärt',
      wechselRueckkehr: 'Sie können jederzeit zuerst zu Waldrechner zurückkehren, wenn Sie vor der Fallklärung noch Zahlen oder Grundlagen prüfen möchten.',
      // Abgrenzung
      abgrenzungText: 'ForestHub bietet eine strukturierte Vorordnung Ihres Wald- oder Forstfalls. ForestHub erstellt kein Gutachten und leistet keine forstliche, rechtliche, steuerliche, finanzielle, Kauf- oder Verkaufsberatung. ForestHub vermittelt keine Makler, Dienstleister oder Käufer.',
      dachHinweis: 'Rechtliche, steuerliche, förderrechtliche und behördliche Zuständigkeiten unterscheiden sich je nach Land und Region. ForestHub ersetzt keine lokale Fachprüfung.',
      // Fallarten-Auswahl
      fallartenTitle: 'Welche Art von Wald- oder Forstfall möchten Sie ordnen?',
      fallartenSubtitle: 'Wählen Sie den Einstieg, der am besten zu Ihrer Situation passt. Sie können Ihren Fall danach frei beschreiben.',
      // Hardcodierte Texte nun als i18n
      ergebnisFokus: 'Sie sehen nicht nur, was bekannt ist – sondern vor allem, wo genauer hingeschaut werden sollte.',
      previewCardTitle: 'Ihre Einordnung – Beispiel',
      kaufKontrastHinweis: 'Die erste Einordnung zeigt Ihnen, wo etwas unklar oder kritisch sein kann. Die Fallklärung hilft Ihnen, genau diese Punkte sauber zu klären.',
      fallartenWaldwert: 'Waldwert einschätzen',
      fallartenWaldwertDesc: 'Wert, Fläche, Bestand, Lage und offene Punkte grob ordnen.',
      fallartenKaufen: 'Wald kaufen',
      fallartenKaufenDesc: 'Kaufpreis, Risiken, Unterlagen, Finanzierung und nächste Prüfungen strukturieren.',
      fallartenVerkaufen: 'Wald verkaufen oder behalten',
      fallartenVerkaufenDesc: 'Optionen, Pflegebedarf, Familie, Wert und langfristige Folgen sortieren.',
      fallartenGeerbt: 'Wald geerbt',
      fallartenGeerbtDesc: 'Nach einem Erbe Überblick gewinnen: Wert, Pflichten, Zustand und nächste Schritte.',
      fallartenSchaden: 'Schaden oder Aufforstung',
      fallartenSchadenDesc: 'Sturm, Käfer, Dürre, Kalamität, Wiederbewaldung und Kosten grob einordnen.',
      fallartenPflege: 'Pflege und Durchforstung',
      fallartenPflegeDesc: 'Pflegebedarf, Durchforstung, Maschineneinsatz oder motormanuelle Arbeit vorstrukturieren.',
      fallartenWild: 'Wildverbiss und Jagd',
      fallartenWildDesc: 'Schäden, Verjüngung, Jagdbezug und wirtschaftliche Folgen sachlich ordnen.',
      fallartenUnsicher: 'Ich bin unsicher',
      fallartenUnsicherDesc: 'Wenn keine Kategorie passt, beschreiben Sie Ihren Fall frei.',
    },
    // Projects
    projects: {
      title: 'Forstprojekte',
      myProjects: 'Meine Projekte',
      newProject: 'Neues Projekt',
      noProjects: 'Keine Projekte gefunden',
      createFirst: 'Erstes Projekt erstellen',
      offers: 'Angebote',
      status: {
        open: 'Offen',
        offers: 'Angebote erhalten',
        assigned: 'Vergeben',
        inProgress: 'In Arbeit',
        completed: 'Abgeschlossen',
      },
    },
    // Providers
    providers: {
      title: 'Forstdienstleister',
      subtitle: 'Qualifizierte Anbieter in Ihrer Region',
      noProviders: 'Keine Anbieter gefunden',
      viewProfile: 'Profil ansehen',
      yearsExperience: 'Jahre Erfahrung',
      contact: 'Kontaktieren',
    },
    // Categories
    categories: {
      holzernte: 'Holzernte',
      rueckung: 'Rückung',
      aufforstung: 'Aufforstung',
      waldpflege: 'Waldpflege',
      co2_projekt: 'CO₂-Klimaschutzprojekt',
    },
    // Steps
    steps: {
      createProject: 'Projekt erfassen',
      createProjectDesc: 'Strukturierte Erfassung Ihres Forstprojekts',
      compareOffers: 'Angebote vergleichen',
      compareOffersDesc: 'Angebote von qualifizierten Fachbetrieben',
      selectProvider: 'Auftrag erteilen',
      selectProviderDesc: 'Entscheidung auf Basis von Preis und Qualifikation',
      rate: 'Dokumentieren',
      rateDesc: 'Nachvollziehbare Projektdokumentation',
    },
    // Footer
    resetPw: {
      felderAusfuellen: 'Bitte füllen Sie alle Felder aus',
      passwortZuKurz: 'Das Passwort muss mindestens 8 Zeichen lang sein',
      passwortUngleich: 'Die Passwörter stimmen nicht überein',
      erfolg: 'Passwort erfolgreich geändert!',
      linkUngueltig: 'Link ungültig',
      geaendert: 'Passwort geändert!',
      neuesPasswort: 'Neues Passwort',
      linkAbgelaufen: 'Der Link ist ungültig oder abgelaufen',
      jetztAnmelden: 'Sie können sich jetzt anmelden',
      sicheresPasswort: 'Wählen Sie ein sicheres Passwort',
      neuenLink: 'Bitte fordern Sie einen neuen Reset-Link an.',
      neuenLinkBtn: 'Neuen Link anfordern',
      zurAnmeldung: 'Zur Anmeldung',
      erfolgText: 'Ihr Passwort wurde erfolgreich geändert.',
      jetztAnmeldenBtn: 'Jetzt anmelden',
      mindestens8: 'Mindestens 8 Zeichen',
      bestaetigen: 'Passwort bestätigen',
      wiederholen: 'Passwort wiederholen',
      aendernBtn: 'Passwort ändern',
      aendernFehler: 'Das Passwort konnte nicht geändert werden. Bitte fordern Sie einen neuen Link an.',
      wirdGeprueft: 'Link wird überprüft...',
    },
    createJob: {
      erfolg: 'Auftrag erfolgreich erstellt!',
      fehler: 'Fehler beim Erstellen des Auftrags',
    },
    footer: {
      tagline: 'Fallklärung für Waldbesitzer',
      rights: 'Alle Rechte vorbehalten',
      privacy: 'Datenschutz',
      terms: 'AGB',
      imprint: 'Impressum',
    },
    // Auth
    auth: {
      email: 'E-Mail',
      password: 'Passwort',
      name: 'Name',
      forgotPassword: 'Passwort vergessen?',
      resetPassword: 'Passwort zurücksetzen',
      resetEmailSent: 'Link gesendet',
      register: 'Registrieren',
      login: 'Anmelden',
      whatToDo: 'Wählen Sie Ihre Rolle',
      createAccount: 'Konto erstellen',
      alreadyRegistered: 'Bereits registriert?',
      loginNow: 'Jetzt anmelden',
      loginFehler: 'Die Anmeldung war nicht erfolgreich. Bitte prüfen Sie Ihre Zugangsdaten.',
      noAccount: 'Noch kein Konto?',
      registerNow: 'Jetzt registrieren',
      ownerOption: 'Waldbesitzer – Klarheit über meinen Wald bekommen',
      providerOption: 'Forstdienstleister – als Dienstleister arbeiten',
      createAccountBtn: 'Konto erstellen',
      termsAgreement: 'Mit der Registrierung stimmen Sie unseren',
      termsLink: 'AGB',
      and: 'und',
      privacyLink: 'Datenschutzbestimmungen',
      agree: 'zu.',
      noSpam: 'Wir versenden keine Werbe-E-Mails. Nur wichtige Hinweise zu Ihrem Fall.',
      change: 'ändern',
      minPassword: 'Mindestens 6 Zeichen',
      premiumBannerTitle: 'Fallklärung (49 € pro Fall)',
      premiumBannerDesc: 'Registrieren Sie sich zunächst kostenlos und beschreiben Sie Ihre Situation. Wenn Sie mehr Klarheit brauchen, können Sie eine Fallklärung buchen.',
    },
    // Assistant
    assistant: {
      title: 'ForestHub Assistent',
      subtitle: 'Fragen zur Plattform?',
      greeting: 'Willkommen bei ForestHub. Wie kann ich Ihnen helfen?',
      placeholder: 'Ihre Frage...',
      thinking: 'Einen Moment...',
      error: 'Die Anfrage konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
      question1: 'Wie funktioniert ForestHub?',
      question2: 'Was kostet eine Durchforstung?',
      question3: 'Welche Leistungen werden angeboten?',
      question4: 'Wie finde ich einen Dienstleister?',
    },
    // Schnell-Check
    schnellcheck: {
      title: 'Ihre Wald-Frage',
      subtitle: 'Beschreiben Sie Ihre Situation in eigenen Worten',
      step1: 'Beschreiben',
      step2: 'Überblick',
      step3: 'Einordnung',
      step4: 'Empfehlung',
      step5: 'Zusammenfassung',
      schrittVon: 'Schritt',
      schrittVonSuffix: 'von 5',
      mikrohilfe: 'Beschreiben Sie in eigenen Worten, was Sie beschäftigt. Es muss nicht perfekt sein – eine grobe Schilderung reicht.',
      placeholder: 'Beschreiben Sie Ihre Situation so genau wie möglich...',
      analyseStarten: 'Einordnung starten',
      analyseLaeuft: 'Analyse läuft...',
      inputTooShort: 'Bitte beschreiben Sie Ihr Anliegen etwas ausführlicher.',
      analyseFehler: 'Die Einordnung konnte nicht erstellt werden.',
      weiter: 'Weiter',
      zurueck: 'Zurück',
      neuStarten: 'Neuen Fall eingeben',
      footerText: 'ForestHub – Fallklärung für Waldbesitzer',
      ichPruefe: 'Ich prüfe den Fall als …',
      beispielAuswaehlen: 'Beispielfall auswählen:',
      oderEigenenFall: 'oder eigenen Fall beschreiben',
      beispieleAnzeigen: 'Beispiele anzeigen',
      zeichen: 'Zeichen',
      wirdAnalysiert: 'Wird analysiert...',
      beschreibungPublic: 'Beschreiben Sie Ihren Fall in eigenen Worten – oder wählen Sie ein Beispiel. Sie erhalten sofort eine erste Einschätzung.',
      ergebnisVorschau: 'Am Ende erhalten Sie eine ForestHub-Fallübersicht: Was ist bereits klar, was ist noch offen, welche Stolpersteine sollten Sie beachten und welche nächsten Schritte können Sie vorbereiten.',
      ergebnisVorschauStruktur: 'Ausgangslage · Offene Punkte · Risiken / Stolpersteine · Fehlende Unterlagen · Nächste Gesprächspunkte',
      beschreibungPrivat: 'Erzählen Sie uns in Ihren eigenen Worten, was Sie beschäftigt.',
      zg_waldbesitzer: 'Waldbesitzer',
      zg_fbg: 'FBG / WBV',
      zg_dienstleister: 'Dienstleister',
      zg_berater: 'Berater',
      zg_kommune: 'Kommune / Körperschaft',
      zg_unsicher: 'Ich bin unsicher',
    },
    fbg: {
      infoBanner: 'Als FBG/WBV erfassen Sie hier die Fälle Ihrer Mitglieder. Beschreiben Sie zunächst einen Fall und klicken Sie auf „Einordnung starten". Nach der Einordnung können Sie bis zu 3 Fälle bündeln – zum Pauschalpreis von 49 €.',
      eingabeTitle: 'Mitgliederfall beschreiben',
      eingabeDesc: 'Beschreiben Sie den Fall eines Ihrer Mitglieder – mit Maßnahme, Standort und Fläche.',
      placeholder: 'z.B. Mitglied Schmidt: 8 ha Fichtenwald in Oberfranken, Durchforstung geplant. Bestand ca. 45 Jahre, Zufahrt über Gemeindestraße.',
      beispieleTitle: 'Typische Mitgliederfälle',
      bspSammelDurchforstungTitel: 'Sammel-Durchforstung',
      bspSammelDurchforstungKurz: '3 Mitglieder mit angrenzenden Flächen wollen gemeinsam durchforsten lassen.',
      bspSammelDurchforstungText: 'Mitglied Meier: 12 ha Fichtenbestand in Oberfranken, 40 Jahre, Durchforstung überfällig. Mitglied Weber: 8 ha angrenzend, gleiche Baumart. Mitglied Braun: 5 ha in 2 km Entfernung, ebenfalls Durchforstung.',
      bspSammelKalamitaetTitel: 'Koordinierte Käferbekämpfung',
      bspSammelKalamitaetKurz: '2 Mitglieder mit Borkenkäferbefall – koordinierte Aufarbeitung sinnvoll.',
      bspSammelKalamitaetText: 'Mitglied Fischer: 4 ha Fichtenbestand in Sachsen, akuter Borkenkäferbefall. Mitglied Koch: 6 ha in der Nachbargemeinde, beginnender Befall. Koordinierte Bekämpfung und gemeinsame Holzvermarktung gewünscht.',
      bspSammelWegebauTitel: 'Gemeinsamer Wegebau',
      bspSammelWegebauKurz: '4 Mitglieder benötigen Zufahrtswege – gemeinsame Ausschreibung senkt Kosten.',
      bspSammelWegebauText: 'Mitglied Lang, Berger, Huber und Kraus: Insgesamt 2,5 km Forstwege in Hessen müssen erneuert werden. Einzelausschreibung zu teuer. Gemeinsame Vergabe an Wegebauunternehmen gewünscht.',
      bspHarvesterTitel: 'Gebündelter Harvester-Einsatz',
      bspHarvesterKurz: '3 Mitglieder planen Holzernte – gemeinsamer Harvester-Einsatz spart Kosten.',
      bspHarvesterText: 'Mitglied Schneider: 15 ha Fichtenbestand in Bayern, Holzernte per Harvester geplant. Mitglied Wagner: 10 ha in 3 km Entfernung, ebenfalls Harvester-Einsatz nötig. Mitglied Becker: 8 ha angrenzend, Fällung und Rückung. Koordinierte Anfahrt und Mengenrabatt gewünscht.',
      bspFoerderungTitel: 'Sammelantrag Waldumbau-Förderung',
      bspFoerderungKurz: '3 Mitglieder wollen Fördermittel für Waldumbau beantragen.',
      bspFoerderungText: 'Mitglied Hoffmann: 6 ha Fichtenreinbestand in Thüringen, Waldumbau zu Mischwald geplant, Förderantrag für Aufforstung nötig. Mitglied Klein: 4 ha in der Nachbargemeinde, gleiche Situation. Mitglied Schäfer: 5 ha, Erstaufforstung nach Kalamität, Waldumbauprämie beantragen.',
    },
    // Dienstleister-Landingpage
    dlPage: {
      anmelden: 'Anmelden',
      heroTag: 'Für Forstdienstleister',
      heroTitle: 'Qualifizierte Anfragen erhalten – nicht suchen',
      heroDesc: 'Waldbesitzer klären auf ForestHub bereits ihren Fall – mit strukturierter Maßnahme, Region, Fläche und Dringlichkeit. Werden Sie dort sichtbar, wo die nächsten Schritte entstehen.',
      heroCta: 'Dienstleister-Profil erstellen – kostenlos starten',
      mehrwertTitle: 'Ihr Vorteil mit ForestHub',
      mehrwertDesc: 'ForestHub ist kein beliebiger Marktplatz. Sondern ein System, das Waldbesitzer bei der Fallklärung unterstützt – und Ihnen dadurch besser vorbereitete Anfragen liefert.',
      mv1Title: 'Besser vorbereitete Fälle',
      mv1Desc: 'Waldbesitzer haben Maßnahme, Region, Fläche und Dringlichkeit bereits strukturiert angegeben.',
      mv2Title: 'Weniger Klärungsaufwand',
      mv2Desc: 'Kein Rätselraten bei der Erstanfrage. ForestHub liefert ein analysiertes Fallbild.',
      mv3Title: 'Regionale Sichtbarkeit',
      mv3Desc: 'Ihr Profil wird nur bei Fällen in Ihren aktiven Bundesländern angezeigt.',
      mv4Title: 'Einordnung nach Spezialisierung',
      mv4Desc: 'Leistungsspektrum, Zertifizierungen und Schwerpunkte werden beim Matching berücksichtigt.',
      mv5Title: 'Zugang zu FBG-Sammelfällen',
      mv5Desc: 'Forstbetriebsgemeinschaften bündeln Fälle – größere Aufträge, weniger Einzelabstimmung.',
      mv6Title: 'Professionelle Darstellung',
      mv6Desc: 'Eigenes Profil mit Zertifizierungen, Leistungsbeschreibung und Referenzen.',
      regionalTitle: 'Regionale Nachfrage-Übersicht',
      regionalDesc: 'Sehen Sie, in welchen Regionen Nachfrage entsteht – basierend auf der Waldstruktur und den auf ForestHub analysierten Fällen.',
      regionalFootnote: 'Die Karte zeigt allgemeine Nachfrageindikatoren. Konkrete Falldaten werden ergänzt, sobald ausreichend Volumen vorhanden ist.',
      pricingTitle: 'Sichtbarkeit, die sich lohnt',
      pricingDesc: 'Starten Sie kostenlos mit einem Basisprofil. Sie werden bei passenden Fällen sichtbar – kein Adresshandel.',
      pricingEmpfohlen: 'Empfohlen',
      pricingIhreWahl: 'Ihre Wahl',
      pricingAusgewaehlt: 'Ausgewählt',
      pricingKostenlos: 'Kostenlos starten',
      pricingStufeWaehlen: 'Stufe wählen',
      pricingFootnote: 'Bezahlte Stufen werden freigeschaltet, sobald ausreichend Nachfrage in Ihrer Region besteht. Einordnung erfolgt nach Passung (Region, Leistung, Zertifizierung), nicht nach Zahlungsbereitschaft.',
      footerTagline: 'ForestHub – Fallklärung für Forstdienstleister',
      footerDienstleister: 'ForestHub – Dienstleister-Plattform',
      footerDatenschutz: 'Datenschutz',
      footerImpressum: 'Impressum',
      headerBadge: 'Dienstleister',
      rolleAnbieter: 'Dienstleister',
      headerProjekte: 'Projekte ansehen',
      nichtGefunden: 'Dienstleister nicht gefunden',
      ladeFehler: 'Die Dienstleister konnten nicht geladen werden. Bitte laden Sie die Seite neu.',
      zurueckUebersicht: 'Zurück zur Übersicht',
      zurueckDienstleister: 'Zurück zu Dienstleistern',
      zurueckAnbieter: 'Zurück zu Anbietern',
      stufeBasis: 'Basis',
      stufeBasisPreis: 'Kostenlos',
      stufeBasisSub: 'Einstieg ohne Risiko',
      stufeSichtbar: 'Sichtbar',
      stufeSichtbarPreis: 'Ab 49 €/Monat',
      stufeSichtbarSub: 'Professionelle Präsenz',
      stufeBevorzugt: 'Bevorzugt',
      stufeBevorzugtPreis: 'Ab 89 €/Monat',
      stufeBevorzugtSub: 'Qualifizierter Marktzugang',
      stufeExklusiv: 'Exklusiv',
      stufeExklusivPreis: 'Auf Anfrage',
      stufeExklusivSub: 'Individuell & bevorzugt',
      stufePremium: 'Premium',
      stufePremiumPreis: 'Ab 149 €/Monat',
      stufePremiumSub: 'Maximale Reichweite',
      basisF1: 'Profil erstellen',
      basisF2: 'Allgemeine Listung',
      basisF3: 'Eingeschränkte Sichtbarkeit',
      sichtbarF1: 'Profil bei passenden Fällen sichtbar',
      sichtbarF2: 'Leistungsprofil-Hervorhebung',
      sichtbarF3: 'Zugang zu anonymisierten Fall-Übersichten',
      sichtbarF4: 'Regionale Präsenz in Ihren Bundesländern',
      bevorzugtF1: 'Bevorzugte Einordnung bei passenden Fällen',
      bevorzugtF2: 'Detaillierte Fall-Übersichten',
      bevorzugtF3: 'FBG-Sammelfall-Zugang',
      bevorzugtF4: 'Regionale Nachfrage-Übersicht',
      bevorzugtF5: 'Einordnung nach Spezialisierung',
      premiumF1: 'Top-Platzierung bei passenden Fällen',
      premiumF2: 'Frühzeitiger Zugang zu neuen Fällen',
      premiumF3: 'Dediziertes Profil mit Bewertungen',
      premiumF4: 'Regionale Einordnung',
      premiumF5: 'Alle Funktionen der unteren Stufen',
    },
    // Sammelfall-Seite (FBG/WBV)
    sammelfall: {
      anmelden: 'Anmelden',
      zurueckSchnellCheck: 'Zurück zur Wald-Frage',
      draftGefunden: 'Gespeicherter Fortschritt gefunden',
      draftFortfahren: 'Sie hatten bereits eine Analyse begonnen. Möchten Sie fortfahren?',
      draftFortfahrenBtn: 'Fortfahren',
      draftVerwerfenBtn: 'Verwerfen',
      titel: 'Mitgliederfälle bündeln',
      fallErfasst: 'Fall erfasst',
      faelleErfasst: 'Fälle erfasst',
      beschreibung: 'Erfassen Sie die Fälle Ihrer Mitglieder einzeln. ForestHub erkennt automatisch, welche Fälle sich für eine gebündelte Vergabe oder koordinierte Umsetzung eignen.',
      buendelungsanalyse: 'Bündelungsanalyse',
      erfassteFaelle: 'Erfasste Mitgliederfälle',
      keineFaelle: 'Noch keine Fälle erfasst.',
      keineFaelleHinweis: 'Fügen Sie den ersten Mitgliederfall hinzu, um die Bündelungsanalyse zu starten.',
      neuerFall: 'Neuen Mitgliederfall beschreiben',
      fallPlaceholder: 'z.B. Mitglied Müller: 8 ha Fichtenwald in Oberfranken, Durchforstung geplant...',
      wirdAnalysiert: 'Wird analysiert...',
      fallHinzufuegen: 'Fall hinzufügen',
      abbrechen: 'Abbrechen',
      weitererFall: 'Weiteren Mitgliederfall hinzufügen',
      empfehlung: 'Empfehlung',
      faelle: 'Fälle',
      buendelHinweis: 'Bündelbare Fälle können Sie als Sammelausschreibung zusammenfassen, um Kosten und Verwaltungsaufwand für Ihre Mitglieder zu reduzieren.',
      ctaTitel: 'Bereit für die gebündelte Vergabe?',
      ctaBeschreibung: 'Registrieren Sie sich kostenlos, um Ihre gebündelten Fälle als Sammelausschreibung zu veröffentlichen und passende Dienstleister zu finden.',
      ctaButton: 'Kostenlos registrieren',
      nichtGefunden: 'Sammelfall nicht gefunden.',
      footerTagline: 'ForestHub – Koordinierte Fallklärung für Forstbetriebsgemeinschaften',
      datenschutz: 'Datenschutz',
      impressum: 'Impressum',
      eingabeFehler: 'Bitte beschreiben Sie den Fall ausführlicher.',
      analysiertFehler: 'Eingabe konnte nicht analysiert werden. Bitte konkreter formulieren.',
      hinzugefuegt: 'Fall hinzugefügt',
      entfernt: 'Fall entfernt',
      entfernenFehler: 'Der Fall konnte nicht entfernt werden.',
      ladeFehler: 'Der Sammelfall konnte nicht geladen werden.',
      unbekannt: 'Unbekannt',
      regionen: 'Regionen',
      baumarten: 'Baumarten',
      gesamtflaeche: 'Gesamtfläche',
      potenzialHoch: 'Hohes Bündelungspotenzial',
      potenzialMittel: 'Mittleres Bündelungspotenzial',
      potenzialEinzeln: 'Einzelfall',
      potenzialGering: 'Geringes Potenzial',
      pdfDownload: 'PDF-Report',
      pdfGestartet: 'PDF-Report wird erstellt...',
      preisHinweis: 'Sammelfall-Paket: Bis zu 3 Mitgliederfälle analysieren und bündeln für 49 EUR.',
      limitErreicht: 'Limit erreicht',
      limitErreichtText: 'Alle 3 Fälle dieses Sammelfall-Pakets sind erfasst.',
      limitErreichtHint: 'Für weitere Mitgliederfälle erstellen Sie bitte einen neuen Sammelfall.',
      harvester: 'Harvester',
      foerderung: 'Förderung',
      harvesterTitle: 'Harvester-Einsatz erkannt',
      harvesterDesc: 'Mehrere Fälle in diesem Sammelfall betreffen Holzernte oder Harvester-Arbeiten. Eine koordinierte Vergabe bietet Einsparpotenzial.',
      harvesterP1: 'Gemeinsame Anfahrt reduziert Transport- und Mobilisierungskosten.',
      harvesterP2: 'Mengenrabatte ab ca. 500 fm sind branchenüblich.',
      harvesterP3: 'Abstimmung der Zeitfenster mit Bodenschutz (Frost, trockene Phasen).',
      foerderungTitle: 'Förderrelevanz erkannt',
      foerderungDesc: 'Einige Fälle berühren förderrelevante Themen. Als FBG/WBV bestehen besondere Fördermöglichkeiten.',
      foerderungP1: 'GAK-Mittel: Förderung von Waldpflege, Aufforstung und Wegebau über Bundesmittel.',
      foerderungP2: 'Sammelantrag: Förderanträge können als FBG gebündelt eingereicht werden.',
      foerderungP3: 'Wichtig: Förderanträge müssen vor Maßnahmenbeginn gestellt werden.',
      einsparung: 'Geschätzte Einsparung',
      kostenBasis: 'Basis:',
      kostenHinweis: 'Unverbindliche Orientierung',
    },
    ausschreibung: {
      titel: 'Als Ausschreibung veröffentlichen',
      beschreibung: 'Machen Sie Ihren Sammelfall für Dienstleister sichtbar. Passende Anbieter können sich bewerben.',
      veroeffentlichenBtn: 'Ausschreibung erstellen',
      titelLabel: 'Titel der Ausschreibung',
      titelPlaceholder: 'z.B. Durchforstung 25 ha Fichtenbestand Oberfranken',
      beschreibungLabel: 'Kurzbeschreibung (optional)',
      beschreibungPlaceholder: 'Was ist besonders wichtig? Zeitrahmen, besondere Anforderungen...',
      emailLabel: 'Kontakt-E-Mail (optional)',
      emailPlaceholder: 'ihre@email.de',
      fristLabel: 'Bewerbungsfrist (optional)',
      wirdVeroeffentlicht: 'Wird veröffentlicht...',
      jetzt: 'Jetzt veröffentlichen',
      fehler: 'Die Ausschreibung konnte nicht erstellt werden.',
      erfolgTitel: 'Ausschreibung veröffentlicht!',
      erfolgText: 'Passende Dienstleister können Ihre Ausschreibung jetzt sehen und sich bewerben.',
      bereitsVeroeffentlicht: 'Ausschreibung ist aktiv',
      dienstleisterSehen: 'Registrierte Dienstleister können sich auf Ihren Sammelfall bewerben.',
    },
    dlAusschreibung: {
      titel: 'Offene Ausschreibungen',
      untertitel: 'Sammelfälle von Waldbesitzergemeinschaften',
      bewerbungen: 'Bewerbungen',
      bewerbenBtn: 'Interesse bekunden',
      nachrichtPlaceholder: 'Beschreiben Sie kurz Ihre Erfahrung und warum Sie für diesen Auftrag geeignet sind...',
      bewerbungErfolg: 'Ihre Bewerbung wurde eingereicht!',
      bewerbungFehler: 'Die Bewerbung konnte nicht gesendet werden.',
    },
    fbgAusschreibung: {
      titel: 'Meine Ausschreibungen',
      untertitel: 'Veröffentlichte Sammelfälle und eingegangene Bewerbungen',
      statusOffen: 'Aktiv',
      keineBewerbungen: 'Noch keine Bewerbungen eingegangen.',
    },
    anbieterDetail: {
      bewertungPlausibilitaet: 'Bewertungen sind erst möglich, wenn der Dienstleister mindestens einen abgeschlossenen Auftrag (Referenz) hinterlegt hat.',
      laden: 'Laden...',
      nichtGefunden: 'Der Anbieter konnte nicht gefunden werden.',
      zurueck: 'Zurück zur Übersicht',
      beispielProfil: 'Beispiel',
      ueberUns: 'Über uns',
      dienstleistungen: 'Dienstleistungen',
      zertifizierungen: 'Zertifizierungen & Nachweise',
      einsatzgebiete: 'Einsatzgebiete',
      einsatzradius: 'Einsatzradius',
      referenzen: 'Referenzen',
      keineReferenzen: 'Noch keine Referenzen hinterlegt',
      bewertungen: 'Bewertungen',
      keineBewertungen: 'Noch keine Bewertungen vorhanden',
      bewertungSchreiben: 'Bewertung schreiben',
      schliessen: 'Schließen',
      ihreBewertung: 'Ihre Bewertung',
      gesamtbewertung: 'Gesamtbewertung',
      qualitaet: 'Qualität',
      kommunikation: 'Kommunikation',
      zuverlaessigkeit: 'Zuverlässigkeit',
      erfahrungsbericht: 'Ihr Erfahrungsbericht',
      erfahrungsberichtPlaceholder: 'Beschreiben Sie Ihre Erfahrung mit diesem Dienstleister...',
      ihrName: 'Ihr Name',
      namePlaceholder: 'Max Mustermann',
      firmaLabel: 'Firma / Organisation',
      firmaPlaceholder: 'z.B. Forstbetriebsgemeinschaft...',
      absenden: 'Bewertung absenden',
      wirdGespeichert: 'Wird gespeichert...',
      erstNachAuftrag: 'Erst nach abgeschlossenem Auftrag möglich',
      pflichtfelder: 'Bitte füllen Sie alle Pflichtfelder aus (Sterne, Name, Kommentar).',
      bewertungGespeichert: 'Ihre Bewertung wurde gespeichert!',
      bewertungFehler: 'Die Bewertung konnte nicht gespeichert werden.',
      kontakt: 'Kontakt aufnehmen',
      nachrichtSenden: 'Nachricht senden',
      websiteLabel: 'Website',
      aufEinenBlick: 'Auf einen Blick',
      bewertungLabel: 'Bewertung',
      erfahrung: 'Erfahrung',
      jahre: 'Jahre',
      jahreErfahrung: 'Jahre Erfahrung',
      beispielHinweis: 'Dies ist ein Beispielprofil zur Veranschaulichung des Marktplatzes.',
      projektBadge: 'Projekt',
    },
    // Dienstleister-Wizard
    dlWizard: {
      stepBasisdaten: 'Basisdaten',
      stepLeistungen: 'Leistungen',
      stepRegionen: 'Einsatzgebiet',
      stepZertifikate: 'Qualifikationen',
      stepAbsenden: 'Absenden',
      schrittVon: 'Schritt',
      von: 'von',
      step1Title: 'Basisdaten',
      step1Desc: 'Wie heißt Ihr Betrieb und wer ist Ansprechpartner?',
      firmaLabel: 'Firmenname',
      kontaktLabel: 'Ansprechpartner',
      emailLabel: 'E-Mail',
      telefonLabel: 'Telefon (optional)',
      step2Title: 'Leistungen',
      step2Desc: 'Welche Dienstleistungen bieten Sie an?',
      leistungenLabel: 'Leistungen auswählen',
      gewaehlt: 'gewählt',
      leistungenHinweis: 'Bitte wählen Sie mindestens eine Leistung aus, um fortzufahren.',
      step3Title: 'Einsatzgebiet',
      step3Desc: 'Wo sind Sie tätig? Ihr Profil wird nur in diesen Regionen angezeigt.',
      bundeslaenderLabel: 'Bundesländer',
      einsatzradiusLabel: 'Einsatzradius (optional)',
      einsatzradiusDesc: 'Maximale Entfernung ab Ihrem Standort in Kilometern.',
      km: 'km',
      bundeslaenderHinweis: 'Bitte wählen Sie mindestens ein Bundesland aus.',
      step4Title: 'Qualifikationen & Beschreibung',
      step4Desc: 'Heben Sie Ihre Stärken hervor – Zertifizierungen und eine ausführliche Beschreibung.',
      zertLabel: 'Zertifizierungen (optional)',
      zertFreitextLabel: 'Weitere Qualifikationen (optional)',
      beschreibungLabel: 'Beschreibung Ihres Betriebs',
      beschreibungDesc: 'Stellen Sie Ihren Betrieb ausführlich vor – Erfahrung, Spezialisierungen, Arbeitsweise und was Sie auszeichnet.',
      step5Title: 'Zusammenfassung',
      step5Desc: 'Prüfen Sie Ihre Angaben und senden Sie das Profil ab.',
      keineAngaben: 'Keine Angaben',
      abbrechen: 'Abbrechen',
      zurueck: 'Zurück',
      weiter: 'Weiter',
      draftTitle: 'Gespeicherter Fortschritt',
      draftDesc: 'Sie hatten bereits ein Profil begonnen. Fortfahren?',
      draftFortfahren: 'Fortfahren',
      draftVerwerfen: 'Verwerfen',
      draftWiederhergestellt: 'Fortschritt wiederhergestellt.',
      wirdGespeichert: 'Wird gespeichert...',
      wirdErstellt: 'Wird erstellt...',
      aenderungenSpeichern: 'Änderungen speichern',
      profilErstellen: 'Profil erstellen',
      profilErstelltTitle: 'Profil erstellt',
      profilAendern: 'Profil ändern',
      planAendern: 'Plan ändern',
      zurStartseite: 'Zur Startseite',
      projekteAnbieter: 'Projekte & Anbieter',
      bereitTitle: 'Bereit, sichtbar zu werden?',
      bereitDesc: 'Erstellen Sie Ihr Basisprofil kostenlos. Bezahlte Sichtbarkeit ab 49 EUR/Monat – dort, wo Waldbesitzer bereits ihre Fälle klären.',
      profilStartenBtn: 'Profil erstellen – kostenlos starten',
      stufeAufBasis: 'Auf Basis ändern',
      gewaehlteStufe: 'Stufe',
      basisHint: 'Das Basisprofil ist kostenlos. Bezahlte Sichtbarkeit ab 49 EUR/Monat – verfügbar, sobald ausreichend Nachfrage besteht.',
      profilAktualisiert: 'Profil aktualisiert!',
      profilAngelegtMsg: 'Profil erstellt!',
      pflichtfelderFehler: 'Bitte füllen Sie alle Pflichtfelder aus.',
      profilFehler: 'Das Profil konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      profilLoeschen: 'Inserat löschen',
      loeschenBestaetigen: 'Möchten Sie Ihr Dienstleister-Profil wirklich dauerhaft löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      profilGeloescht: 'Ihr Profil wurde gelöscht.',
      loeschenFehler: 'Das Profil konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
    },
    // Dashboard
    dashboard: {
      title: 'Meine Fälle',
      countSingle: 'gespeicherter Fall',
      countPlural: 'gespeicherte Fälle',
      empty: 'Stellen Sie Ihre erste Wald-Frage',
      neuerCheck: 'Neue Wald-Frage',
      emptyTitle: 'Noch keine Fälle gespeichert',
      emptyDescription: 'Beschreiben Sie Ihre Situation. ForestHub gibt Ihnen eine erste Einschätzung mit offenen Punkten und nächsten Schritten.',
      emptyButton: 'Jetzt Situation beschreiben',
      sammelfaelleTitle: 'Meine Sammelfälle (FBG/WBV)',
      sammelfaelleSubtitle: 'Bündeln Sie Mitgliederfälle für koordinierte Vergaben',
      sammelfaelleDesc: 'Pro Sammelfall können bis zu 3 Mitgliederfälle erfasst, analysiert und gebündelt werden. ForestHub erkennt automatisch, welche Fälle sich für eine gemeinsame Ausschreibung eignen.',
      neuerSammelfall: 'Neuen Sammelfall erstellen (49 EUR)',
      sammelfall: 'Sammelfall',
      fallSingle: 'Fall',
      fallPlural: 'Fälle',
      buendelbar: 'Bündelbar',
      sammelfaelleEmpty: 'Noch keine Sammelfälle erstellt.',
      sammelfaelleEmptyHint: 'Erfassen Sie bis zu 3 Mitgliederfälle pro Sammelfall-Paket (49 EUR).',
      sammelfaelleStart: 'Ersten Sammelfall erstellen',
      sammelfallFehler: 'Der Sammelfall konnte nicht erstellt werden.',
      vorentscheidung: 'Vorentscheidung',
      sinnvollsterWeg: 'Sinnvollster Weg',
      risiko: 'Risiko',
      offenerPunkt: 'Offener Punkt',
      offenePunkte: 'Offene Punkte',
      einschaetzung: 'Einschätzung',
      angabenBearbeiten: 'Angaben bearbeiten',
      lagebeurteilungAnfordern: 'Lagebeurteilung anfordern',
      lagebeurteilungNeu: 'Lagebeurteilung neu berechnen',
      lagebeurteilungWird: 'Lagebeurteilung wird erstellt...',
      lagebeurteilungDauer: 'Dies dauert etwa 15-30 Sekunden. Die Seite muss nicht neu geladen werden.',
      lagebeurteilungFertig: 'Lagebeurteilung fertig.',
      lagebeurteilungFehler: 'Lagebeurteilung fehlgeschlagen',
      bundeslandSetzen: 'Bundesland jetzt setzen',
      bundeslandPflicht: 'Für eine regionale Einschätzung muss zuerst das Bundesland festgelegt werden.',
      pdfSichern: 'Ergebnis als PDF sichern',
      pdfStufeC: 'Die ausführliche Fallklärung enthält eine vollständige Einordnung mit Stolpersteinen und nächsten Schritten.',
      interesseVormerken: 'Interesse vormerken',
      vorschauPdf: 'Kurzfassung herunterladen',
      vorschauPdfHinweis: 'Kompakte Zusammenfassung Ihres Falls als PDF.',
      vollstaendigeVorlage: 'Fallklärung',
      vollstaendigeVorlageHinweis: 'Ausführliche Einordnung mit Stolpersteinen, nächsten Schritten und PDF.',
      stufeCFreischalten: 'Fallklärung buchen · 49 €',
      stufeCFreigeschaltet: 'Fallklärung abgeschlossen – bereit zum Download',
      stufeCZahlungLaeuft: 'Zahlung wird verarbeitet …',
      stufeCZahlungHinweis: 'Falls die Zahlung nicht abgeschlossen wurde, können Sie es erneut versuchen oder den Vorgang abbrechen.',
      stufeCAbbrechen: 'Abbrechen',
      stufeCAbgebrochen: 'Zahlungsvorgang abgebrochen.',
      stufeCErfolg: 'Fallklärung freigeschaltet!',
      stufeCAbgelaufen: 'Zahlungssitzung abgelaufen. Bitte erneut versuchen.',
      stufeCTimeout: 'Verarbeitung dauert etwas länger. Der Status aktualisiert sich automatisch.',
      stufeCRegelbasiert: 'Die Fallklärung setzt eine Lagebeurteilung voraus. Sie können die Lagebeurteilung jetzt anfordern.',
      stufeCErneut: 'Erneut versuchen',
      stufeCWirdGestartet: 'Wird gestartet …',
      stufeCZahlungWirdGeprueft: 'Zahlung wird geprüft …',
      testmodusBanner: 'Interner Testmodus – keine echte Zahlung',
      testmodusFreischalten: 'Test-Freischalten',
      testmodusReset: 'Test zurücksetzen',
      testmodusErfolg: 'Testfreischaltung aktiviert.',
      testmodusResetErfolg: 'Testfreischaltung zurückgesetzt.',
      toastLbFertig: 'Lagebeurteilung fertig.',
      toastLbFehler: 'Die Lagebeurteilung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      toastGespeichert: 'Angaben gespeichert.',
      toastSpeichernFehler: 'Die Angaben konnten nicht gespeichert werden.',
      toastBundeslandFehlt: 'Bitte zuerst ein Bundesland setzen.',
      toastLbWird: 'Lagebeurteilung wird erstellt...',
      toastLbStartFehler: 'Die Lagebeurteilung konnte nicht gestartet werden.',
      toastKurzfassung: 'Kurzfassung wird heruntergeladen.',
      toastKurzfassungFehler: 'Die Kurzfassung konnte nicht heruntergeladen werden.',
      toastFkDownload: 'Fallklärung wird heruntergeladen.',
      toastFkFehler: 'Die Fallklärung konnte nicht heruntergeladen werden.',
      toastSzenarioDownload: 'Szenario-Anhang wird heruntergeladen.',
      toastSzenarioHinweis: 'Führen Sie zuerst ein Szenario aus, um den Anhang zu erstellen.',
      toastSzenarioFehler: 'Der Szenario-Anhang konnte nicht heruntergeladen werden.',
      toastZahlungFehler: 'Der Zahlungsvorgang konnte nicht gestartet werden.',
      toastTestFehler: 'Die Test-Freischaltung konnte nicht durchgeführt werden.',
      toastTestResetFehler: 'Das Test-Zurücksetzen konnte nicht durchgeführt werden.',
      toastInteresse: 'Interesse registriert!',
      toastInteresseFehler: 'Ihre Vormerkung konnte nicht gespeichert werden.',
      interesseVorgemerkt: 'Interesse vorgemerkt',
      toastSitzungAbgelaufen: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      toastLadeFehler: 'Ihre Analysen konnten nicht geladen werden.',
      fortFallBeschrieben: 'Fall beschrieben',
      fortPflichtangaben: 'Pflichtangaben',
      fortLbAnfordern: 'Lagebeurteilung',
      fortLbFertig: 'Ergebnis da',
      fortStufeCFreischalten: 'Fallklärung',
      jetztTun: 'Jetzt zu tun',
      danachPassiert: 'Danach',
      jetztBundesland: 'Setzen Sie das Bundesland, damit die regionale Einschätzung möglich wird.',
      jetztLbAnfordern: 'Fordern Sie die Lagebeurteilung an – sie dauert ca. 15–30 Sekunden.',
      jetztLbWarten: 'Die Lagebeurteilung wird gerade erstellt. Bitte kurz warten.',
      jetztStufeCFreischalten: 'Sie können jetzt die Fallklärung buchen.',
      jetztFertig: 'Ihre Fallklärung steht zum Download bereit.',
      danachLb: 'Sie können die Lagebeurteilung anfordern.',
      danachStufeC: 'Danach können Sie die Fallklärung buchen.',
      danachPdf: 'Ausführliche Fallklärung als PDF zum Download.',
      detailsEinblenden: 'Details einblenden',
      detailsAusblenden: 'Details ausblenden',
      freischaltUebersicht: 'Was Sie durch die Fallklärung erhalten',
      freischaltF1: 'Einordnung Ihres Falls aus mehreren Blickwinkeln',
      freischaltF2: 'Regionale Besonderheiten und Regelwerke',
      freischaltF3: 'Nächste sinnvolle Schritte',
      freischaltF4: 'Alles als PDF zum Ausdrucken und Mitnehmen',
    },
    szenario: {
      titel: 'Was passiert wenn...?',
      gesperrtHinweis: 'Szenarien sind Teil der Fallklärung.',
      ladenOptionen: 'Szenario-Optionen werden geladen...',
      keineOptionen: 'Für diesen Fall stehen keine Szenarien zur Verfügung.',
      fehlerLaden: 'Szenario-Optionen konnten nicht geladen werden.',
      fehlerAuswertung: 'Die Szenario-Auswertung konnte nicht durchgeführt werden. Bitte versuchen Sie es erneut.',
      bezugAuf: 'Bezug auf',
      wasAendertSich: 'Was ändert sich voraussichtlich?',
      wasWirdKritischer: 'Was wird kritischer oder entspannter?',
      welcheOffenenPunkte: 'Welche offenen Punkte verschieben sich?',
      wasWaereSinnvoll: 'Was wäre jetzt sinnvoll zu prüfen?',
      disclaimer: 'Szenario-Einordnung auf Basis Ihrer Angaben. Keine Garantie, keine Rechtsberatung.',
    },
    stufeD: {
      titel: 'Wie geht es weiter?',
      laden: 'Anschlussoptionen werden geladen...',
      reife_bereit: 'Entscheidungsbereit',
      reife_teilweise: 'Teilweise entscheidungsbereit',
      reife_noch_nicht: 'Noch nicht entscheidbar',
      naechsterSchritt: 'Nächster konkreter Schritt',
      typ_klaerung: 'Klärung',
      typ_aktion: 'Aktion',
      typ_entscheidung: 'Entscheidung',
      typ_warten: 'Abwarten',
      disclaimer: 'Abgeleitet aus Ihrer Lagebeurteilung. Ersetzt keine Fachberatung.',
    },
    // Produkt-Konzepte
    produkt: {
      weiterarbeiten: 'Weitermachen',
      vertieftePruefung: 'Fallklärung',
      lagebeurteilung: 'Lagebeurteilung',
      analyseSpeichern: 'Fall speichern',
      ergebnisAlsPdf: 'Ergebnis als PDF sichern',
      stufeA: 'Kostenloser Schnell-Check ohne Registrierung',
      stufeB: 'Kostenlos mit Registrierung – Fall speichern und später weitermachen',
      stufeC: 'Fallklärung – ausführliche Einordnung mit PDF',
      ctaAtoB: 'Fall speichern und später weitermachen',
      ctaBtoC: 'Fallklärung buchen',
      ctaMehrKlarheit: 'Fallklärung ansehen – 49 €',
      ctaPdfExport: 'Ergebnis als PDF sichern',
      ctaNeuberechnung: 'Lagebeurteilung neu berechnen',
    },
    profil: {
      titel: 'Mein Profil',
      anbieterProfil: 'Ihr Anbieterprofil bearbeiten',
      waldbesitzerProfil: 'Ihr Waldbesitzer-Profil',
      grunddaten: 'Grunddaten',
      firmenname: 'Firmenname',
      bundesland: 'Bundesland',
      ort: 'Ort',
      telefon: 'Telefon',
      website: 'Website',
      beschreibung: 'Beschreibung',
      beschreibungPlaceholderAnbieter: 'Beschreiben Sie Ihr Unternehmen...',
      beschreibungPlaceholderWaldbesitzer: 'Erzählen Sie etwas über sich und Ihren Wald...',
      erfahrungJahre: 'Jahre Erfahrung',
      dienstleistungen: 'Dienstleistungen',
      einsatzgebiete: 'Einsatzgebiete',
      einsatzradius: 'Einsatzradius',
      einsatzradiusHinweis: 'Maximale Entfernung ab Ihrem Standort in Kilometern.',
      aenderungenSpeichern: 'Änderungen speichern',
      wirdGespeichert: 'Wird gespeichert...',
      gespeichert: 'Profil gespeichert',
      speichernFehler: 'Ihre Angaben konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      ladeFehler: 'Ihr Profil konnte nicht geladen werden. Bitte laden Sie die Seite neu.',
      auswahl: 'Auswählen',
    },
    vertrauen: {
      titel: 'Grundlagen & Hinweise',
      laden: 'Wird geladen...',
      grundlagenTitel: 'Grundlagen dieser Einordnung',
      anlaufstellenTitel: 'Mögliche Anlaufstellen',
    },
    fa: {
      erkanntTitel: 'Das haben wir verstanden',
      erkannteMerkmale: 'Erkannte Merkmale',
      fehlendeAngaben: 'Noch offen (optional)',
      erklaerungAusblenden: 'Erklärung ausblenden',
      warum: 'Warum?',
      warumWichtig: 'Warum ist das wichtig?',
      ausblenden: 'Ausblenden',
      ihreAngabe: 'Ihre Angabe...',
      aendern: '(ändern)',
      nebenthema: 'Nebenthema',
      weniger: 'Weniger',
      details: 'Details',
      nebenthemaErklaerung: 'Dieses Thema wird neben dem Hauptthema berücksichtigt und kann die Empfehlung beeinflussen.',
      weitereThemen: 'Weitere erkannte Themen',
      nebenHauptthemaPrefix: 'Neben dem Hauptthema',
      nebenHauptthemaSuffix: 'wurden weitere Themen erkannt. Diese beeinflussen die Empfehlung und können einzeln geprüft werden.',
      widersprueche: 'Widersprüche in Ihren Angaben',
      richtigstellung: 'Richtigstellung, z.B. \'Es sind 15 ha, nicht 5 ha\'',
      klaeren: 'Klären',
      offenePunkteKlaeren: 'Offene Punkte klären',
      offenePunkteFehlen: 'Diese Angaben helfen für eine genauere Einschätzung. Wenn Sie unsicher sind, lassen Sie die Felder einfach offen.',
      rueckfragen: 'Rückfragen an Sie',
      freitextHinzufuegen: 'Freitext-Ergänzung hinzufügen',
      weitereInfos: 'Weitere Informationen ergänzen',
      freitextPlaceholder: 'Beschreiben Sie, was ForestHub zusätzlich wissen sollte...',
      unsereEinschaetzung: 'Unsere Einschätzung',
      soOrdnenWir: 'So ordnen wir Ihren Fall ein – basierend auf Ihren Angaben.',
      unsereEmpfehlung: 'Unsere Empfehlung',
      geschaetzterAufwand: 'Geschätzter Aufwand:',
      warumEmpfehlung: 'Warum diese Empfehlung?',
      hinweis1: '1 Hinweis',
      hinweiseN: 'Hinweise',
      anzeigen: 'anzeigen',
      vorlaeufig: 'Vorläufiges Ergebnis',
      sinnvollsterWeg: 'Sinnvollster Weg laut Datenlage',
      groesstesRisiko: 'Größtes erkennbares Risiko',
      nochZuKlaeren: 'Noch zu klären',
      vertieftePruefung: 'Fallklärung',
      vertiefteBeschreibung: 'Wenn Sie mehr Klarheit brauchen, können Sie eine Fallklärung buchen. Sie erhalten eine ausführliche Einordnung mit Stolpersteinen, nächsten Schritten und einem PDF zum Mitnehmen.',
      wirdGeprueft: 'Das prüfen wir zusätzlich für Ihren Fall',
      inVorbereitung: 'So geht es weiter',
      belastbareHilfe: 'Registrieren Sie sich kostenlos, um Ihren Fall zu speichern. Danach können Sie die Fallklärung für 49 € buchen.',
      interesseAnzeigen: 'Fallklärung vormerken (49 €)',
      interesseBestaetigt: 'Interesse vorgemerkt',
      analyseSpeichernOffen: 'Kostenlos registrieren und Fall speichern',
      zurueck: 'Zurück',
      neuenFall: 'Neuen Fall analysieren',
      warumEmpfohlen: 'Warum wir das empfehlen',
      jetztTun: 'Das sollten Sie jetzt tun',
      woraufAchten: 'Worauf Sie achten sollten',
      stolpersteine: 'Stolpersteine für Ihren Fall',
      wasPassiertWenn: 'Was passiert wenn?',
      quellenAusblenden: 'Quellenübersicht ausblenden',
      quellenAnzeigen: 'Welche Quellen stützen diese Empfehlung?',
      quelle: 'Quelle',
      quellen: 'Quellen',
      zB: 'z.B.',
      quellenDisclaimer: 'ForestHub bietet keine Rechtsberatung. Sie erhalten eine Einordnung auf Basis öffentlich zugänglicher Regelwerke und Fachliteratur.',
      mitgliederBuendeln: 'Mitgliederfälle bündeln',
      sindDienstleister: 'Sie sind Forstdienstleister?',
      profilErstellen: 'Erstellen Sie Ihr Profil und werden Sie bei passenden Fällen sichtbar.',
      dienstleisterProfil: 'Dienstleister-Profil erstellen',
      einordnungSichern: 'Diese geprüfte Einordnung sichern',
      empfehlungSpeichern1: 'Begründete Empfehlung mit Quelleneinordnung speichern',
      empfehlungSpeichern2: 'Stolpersteine und Handlungsschritte nachvollziehbar behalten',
      empfehlungSpeichern3: 'Später die ausführliche Fallklärung buchen (49 €)',
      empfehlungSichern: 'Einordnung sichern und weitermachen',
      projektErstellen: 'Projekt aus dieser Empfehlung erstellen',
      andereWege: 'Andere mögliche Wege ansehen',
      sinnvoll: 'Sinnvoll,',
      landesspezifisch: 'landesspezifisch',
      tagRechtlich: 'rechtlich relevant',
      tagNachweisbezogen: 'nachweisbezogen',
      tagFoerderrelevant: 'förderrelevant',
      tagFachlich: 'fachlich empfohlen',
      tagOekologisch: 'ökologisch riskant',
      tagPraxisnah: 'praxisnah begründet',
      assistZuKurz: 'Wir brauchen etwas mehr von Ihnen',
      assistNichtForstlich: 'Wir konnten kein forstliches Thema erkennen',
      assistRueckfrage: 'Noch nicht genug für eine Einordnung',
      assistBelastbar: 'ForestHub gibt nur dann eine Einschätzung, wenn genug Informationen vorliegen.',
      assistWuerdHelfen: 'Das würde uns weiterhelfen:',
      assistErgaenzen: 'Ergänzen Sie Ihre Beschreibung:',
      assistPlaceholder: 'Beschreiben Sie Ihre Situation genauer...',
      assistEingabeAendern: 'Eingabe ändern',
      assistErneutAnalysieren: 'Erneut analysieren',
      assistWirdAnalysiert: 'Wird analysiert...',
      panelTitel: 'Klärungsassistent',
      panelSchritt: 'Schritt',
      panelPlaceholder: 'Frage stellen, z.B. \'Warum wurde Kalamität erkannt?\'',
      kontextEingabe: 'Ihre Eingabe',
      kontextBearbeiten: 'Bearbeiten',
      kontextKorrigieren: 'Eingabe korrigieren',
      kontextZgAendern: 'Zielgruppe ändern',
      kontextAnalysiert: 'Analysiert...',
      kontextErneutAnalysieren: 'Erneut analysieren',
      kontextAbbrechen: 'Abbrechen',
      entwurfTitel: 'Angaben bearbeiten',
      entwurfBundesland: 'Bundesland',
      entwurfPflicht: '(Pflicht)',
      entwurfPflichtWarum: 'Für bundeslandspezifische Förderprogramme und Regelwerke.',
      entwurfBundeslandWaehlen: 'Bundesland wählen',
      entwurfBundeslandGeaendert: 'Sie haben das Bundesland geändert. Die bisherige regionale Einordnung wird durch eine neue Berechnung ersetzt.',
      entwurfFallbeschreibung: 'Fallbeschreibung',
      entwurfFallWarum: 'Eine grobe Beschreibung reicht – Sie können jederzeit ergänzen.',
      entwurfSchutzstatus: 'Schutzstatus',
      entwurfErschliessung: 'Erschließung',
      entwurfEigentumsform: 'Eigentumsform',
      entwurfOptional: 'Optional – nur ausfüllen, wenn bekannt',
      entwurfHanglage: 'Hanglage vorhanden',
      entwurfBekannteProbleme: 'Bekannte Probleme / Unsicherheiten',
      entwurfBekannteWarum: 'Nur ergänzen, wenn bereits bekannt.',
      entwurfBekannteHint: 'z.B. Borkenkäfer am Nachbargrundstück, unklare Grenzverläufe...',
      entwurfSpeichern: 'Speichern',
      entwurfSpeichert: 'Speichern...',
      entwurfAbbrechen: 'Abbrechen',
      schutzKeiner: 'Kein Schutzstatus bekannt',
      schutzNsg: 'Naturschutzgebiet (NSG)',
      schutzFfh: 'FFH-Gebiet',
      schutzWsg: 'Wasserschutzgebiet',
      schutzLsg: 'Landschaftsschutzgebiet',
      schutzUnbekannt: 'Nicht sicher',
      erschliessungGut: 'Gut erschlossen',
      erschliessungTeilweise: 'Teilweise erschlossen',
      erschliessungNicht: 'Nicht erschlossen',
      erschliessungUnbekannt: 'Nicht bekannt',
      eigentumPrivat: 'Privatwald',
      eigentumKoerperschaft: 'Körperschaftswald',
      eigentumStaat: 'Staatswald',
      eigentumUnbekannt: 'Nicht bekannt',
      lbKurzfazit: 'Kurzfazit',
      lbVorentscheidungKontext: 'Vorentscheidung im Kontext',
      lbWasFehlt: 'Was vor einer Entscheidung fehlt',
      lbStolpersteineRisiken: 'Stolpersteine und Risiken',
      lbFachlicheEinordnung: 'Fachliche Einordnung',
      lbRegionaleEinordnung: 'Regionale Einordnung:',
      lbWasSinnvoll: 'Was jetzt sinnvoll ist',
      lbDisclaimer: 'ForestHub ordnet Ihren Fall anhand forstfachlicher Grundlagen und regionaler Rahmenbedingungen vor. Die Einschätzung dient der Orientierung und ersetzt keine behördliche Entscheidung, Rechtsberatung oder Förderauskunft. Regionale Auslegung kann abweichen.',
      herkunftNutzer: 'Aus Ihren Angaben',
      herkunftAbleitung: 'Naheliegende Ableitung',
      herkunftRegional: 'Regional zu prüfen',
      herkunftFachlich: 'Fachlich gesondert prüfen',
      perspFoerderung: 'Förderung',
      perspOekologie: 'Ökologie',
      perspOekonomie: 'Ökonomie',
      perspBetriebswirtschaft: 'Betriebswirtschaft',
      perspNaturschutz: 'Naturschutz',
      perspGesetze: 'Gesetze und Verordnungen',
      stolpBetriebswirtschaftlich: 'Betriebswirtschaftlich',
      stolpOekologisch: 'Ökologisch',
      stolpOrganisatorisch: 'Organisatorisch',
      stolpGesetzlich: 'Gesetzlich',
      stolpFoerderbezogen: 'Förderbezogen',
      stolpNaturschutz: 'Naturschutz',
      phaseJetzt: 'Jetzt klären',
      phaseDann: 'Dann prüfen',
      phaseDanach: 'Danach entscheiden',
      regFoerderung: 'Förderung',
      regLandesrecht: 'Landesrecht',
      regNaturschutz: 'Naturschutz',
      regVerwaltung: 'Verwaltung',
      relevanzHoch: 'Hoch',
      bspDurchforstungTitel: 'Durchforstung planen',
      bspDurchforstungKurz: 'Dichter Fichtenbestand in Bayern soll professionell durchforstet werden.',
      bspDurchforstungText: 'Ich habe 15 Hektar Fichtenwald in Bayern, der dringend durchforstet werden muss. Der Bestand ist etwa 40 Jahre alt und sehr dicht. Ich brauche einen Dienstleister, der das professionell macht. PEFC-Zertifizierung ist wichtig.',
      bspKalamitaetTitel: 'Borkenkäfer-Befall',
      bspKalamitaetKurz: 'Akuter Käferbefall auf Fichtenbestand – schnelle Aufarbeitung nötig.',
      bspKalamitaetText: 'Borkenkäferbefall auf 6 ha Fichtenbestand in Sachsen. Sofortige Aufarbeitung nötig. Der Befall breitet sich aus und ich brauche dringend einen erfahrenen Dienstleister.',
      bspFoerderungTitel: 'Waldumbau mit Förderung',
      bspFoerderungKurz: 'Fichtenmonokultur soll mit Fördermitteln zu Mischwald umgebaut werden.',
      bspFoerderungText: 'Ich möchte einen Förderantrag für Waldumbau stellen. 15 ha Fichte sollen zu Mischwald umgebaut werden. Standort Bayern. Ich brauche einen Berater, der mich durch den Antrag begleitet.',
      bspAufforstungTitel: 'Wiederaufforstung nach Sturm',
      bspAufforstungKurz: 'Sturmfläche in Niedersachsen soll mit Douglasie und Buche bepflanzt werden.',
      bspAufforstungText: 'Nach dem Sturm im Herbst muss eine Kahlfläche aufgeforstet werden. Etwa 10 Hektar in Niedersachsen. Geplant ist eine Mischung aus Douglasie und Buche. Ein Dienstleister soll die Pflanzung übernehmen.',
      bspNeophytenTitel: 'Traubenkirsche bekämpfen',
      bspNeophytenKurz: 'Invasive Traubenkirsche verdrängt heimische Verjüngung im Mischwald.',
      bspNeophytenText: 'In meinem 4 ha großen Mischwald in Brandenburg breitet sich die spätblühende Traubenkirsche massiv im Unterholz aus und verdrängt die heimische Naturverjüngung. Ich brauche professionelle Bekämpfung (Ringeln, Fällung mit Stockbehandlung) und einen Plan für die Nachkontrolle.',
      bspWildschadenTitel: 'Wildverbiss stoppen',
      bspWildschadenKurz: 'Junge Eichen und Buchen werden durch Rehwild stark verbissen.',
      bspWildschadenText: 'Auf 3 ha Aufforstung in Rheinland-Pfalz werden meine jungen Eichen und Buchen massiv vom Rehwild verbissen. Trotz Jagd reicht der Schutz nicht. Ich brauche eine Empfehlung: Wuchshüllen, Drahthosen oder Zaun? Was ist bei meiner Fläche sinnvoll?',
    },
    // Eingabe-Assistent (live Hilfe beim Tippen)
    eingabeAssistent: {
      erkannt: 'Erkannt',
      tipp: 'Für eine genauere Einordnung ergänzen Sie:',
      vollstaendig: 'Gute Beschreibung – alle wichtigen Angaben vorhanden.',
      vorlage: 'Vorlage verwenden',
      formBundesland: 'Bundesland',
      formBundeslandWaehlen: 'Bitte wählen...',
      formFlaeche: 'Ungefähre Fläche',
      formVorschau: 'Vorschau:',
      formUebernehmen: 'In Textfeld übernehmen',
    },
    // Qualitätsanzeige (Ergebnis-Vollständigkeit)
    qualitaet: {
      basis: 'Ihre Einordnung basiert auf',
      von: 'von',
      angaben: 'möglichen Angaben',
      hinweis: 'Je mehr Angaben Sie machen, desto genauer wird die Einordnung.',
      ergaenzen: 'Angaben ergänzen',
    },
    // Geführte Rückfragen
    gefuehrt: {
      titelZuKurz: 'Erzählen Sie uns mehr',
      titelNichtForstlich: 'Wir brauchen einen forstlichen Bezug',
      titelRueckfrage: 'Noch ein paar Angaben nötig',
      intro: 'Beantworten Sie einfach die folgenden Fragen – wir ergänzen Ihren Text automatisch.',
      oderFreitext: 'Oder beschreiben Sie es direkt:',
      freitextPlaceholder: 'Ihre Beschreibung...',
      uebernehmen: 'Übernehmen und analysieren',
      bisherGesammelt: 'Bisher gesammelt:',
      zurueckZurEingabe: 'Selbst formulieren',
      allesZuruecksetzen: 'Zurücksetzen',
      wasPassiert: 'Was ist bei Ihrem Wald los?',
      wasPassiertOptionen: ['Borkenkäferbefall', 'Sturmschäden', 'Durchforstung nötig', 'Aufforstung geplant', 'Wald geerbt', 'Holzverkauf', 'Sonstiges'],
      woLiegt: 'In welchem Bundesland liegt Ihr Wald?',
      wieGross: 'Wie groß ist die Fläche ungefähr?',
      wieGrossOptionen: ['Unter 5 ha', '5–15 ha', '15–50 ha', 'Über 50 ha', 'Weiß ich nicht'],
      wieDringend: 'Wie dringend ist es?',
      wieDringendOptionen: ['Sofort / Akut', 'In den nächsten Wochen', 'Dieses Jahr', 'Flexibel'],
    },
    // Berater
    berater: {
      bspForsteinrichtungTitel: 'Forsteinrichtung erstellen',
      bspForsteinrichtungKurz: 'Betriebsplanung für einen 120-ha-Privatwald in Hessen steht an.',
      bspForsteinrichtungText: 'Für einen Mandanten muss eine Forsteinrichtung (Betriebsplan) für 120 ha Privatwald in Hessen erstellt werden. Letzte Einrichtung vor über 15 Jahren. Inventur, Hiebsplanung und Maßnahmenplanung für 10 Jahre benötigt. Wer kann die Bestandsaufnahme und Planung übernehmen?',
      bspWaldwertTitel: 'Waldwertgutachten für Erbschaft',
      bspWaldwertKurz: 'Verkehrswert eines geerbten Waldes muss für das Finanzamt ermittelt werden.',
      bspWaldwertText: 'Im Rahmen einer Erbschaft muss der Verkehrswert von 25 ha Mischwald in Bayern ermittelt werden. Das Finanzamt verlangt ein Sachverständigengutachten. Bestand: überwiegend Fichte (60 J.) und Buche (80 J.). Wer erstellt ein gerichtsfestes Waldwertgutachten?',
      bspFoerdermittelTitel: 'Fördermittelberatung Waldumbau',
      bspFoerdermittelKurz: 'Waldbesitzer will Förderung für den Umbau einer Kiefernmonokultur beantragen.',
      bspFoerdermittelText: 'Ein Waldbesitzer in NRW möchte 18 ha Kiefernmonokultur mit Fördermitteln zu Mischwald umbauen. Welche Förderprogramme kommen in Frage (GAK, Extremwetterrichtlinie NRW)? Ich brauche Unterstützung bei der Antragstellung und Maßnahmenplanung.',
      bspWildschadenTitel: 'Wildschadensgutachten',
      bspWildschadenKurz: 'Gutachterliche Schätzung von Schälschäden durch Rotwild an jungem Bergahorn.',
      bspWildschadenText: 'Auf einer 8 ha großen Fläche in Baden-Württemberg sind massive Schälschäden durch Rotwild an Bergahorn (ca. 20 Jahre) entstanden. Der Waldbesitzer will Schadenersatz von der Jagdgenossenschaft geltend machen. Wer erstellt ein amtlich anerkanntes Wildschadensgutachten?',
      bspNaturschutzTitel: 'FFH-Managementplanung',
      bspNaturschutzKurz: 'Bewirtschaftungsplan für Waldflächen im FFH-Gebiet muss erstellt werden.',
      bspNaturschutzText: 'Für 40 ha Wald in einem FFH-Gebiet in Thüringen muss ein Managementplan erstellt werden. Lebensraumtypen (Hainsimsen-Buchenwald 9110, Sternmieren-Eichen-Hainbuchenwald 9160) sind zu kartieren und Erhaltungsmaßnahmen zu planen. Wer hat Erfahrung mit FFH-Managementplänen?',
    },
    // Kommune
    kommune: {
      bspVerkehrssicherungTitel: 'Verkehrssicherung Kreisstraße',
      bspVerkehrssicherungKurz: 'Baumkontrolle und Totholzentnahme entlang einer Kreisstraße erforderlich.',
      bspVerkehrssicherungText: 'Entlang einer 2 km langen Kreisstraße stehen ca. 200 Laubbäume (Buche, Eiche, Esche) im Kommunalwald. Mehrere Bäume zeigen Trockenheitsschäden und Totholz in der Krone. Wir brauchen eine fachgerechte Baumkontrolle nach FLL-Richtlinie und anschließende Verkehrssicherungsmaßnahmen (Totholzentnahme, ggf. Fällung).',
      bspStadtwaldTitel: 'Bewirtschaftungskonzept Stadtwald',
      bspStadtwaldKurz: 'Nachhaltiges Konzept für einen 80-ha-Stadtwald mit Erholungs- und Nutzfunktion.',
      bspStadtwaldText: 'Unsere Gemeinde besitzt 80 ha Stadtwald. Der bisherige Förster geht in den Ruhestand. Wir brauchen ein aktuelles Bewirtschaftungskonzept, das Holznutzung, Erholung, Naturschutz und Klimaanpassung berücksichtigt. Wer erstellt einen integrierten Bewirtschaftungsplan?',
      bspSpielplatzTitel: 'Sicherheitskonzept Waldkindergarten',
      bspSpielplatzKurz: 'Baumkontrolle und Flächensicherung für einen Waldkindergarten-Standort.',
      bspSpielplatzText: 'Unsere Gemeinde plant einen Waldkindergarten auf einer 0,5 ha großen Fläche im Gemeindewald. Vor der Genehmigung brauchen wir ein Baumgutachten (Standsicherheit, Totholz, Ast-Bruchgefahr) und ein Sicherheitskonzept. Welcher Sachverständige kann das Areal bewerten?',
      bspSturmschadenTitel: 'Sturmschäden im Kommunalwald',
      bspSturmschadenKurz: 'Großflächige Sturmschäden im Gemeindewald erfordern schnelle Räumung und Planung.',
      bspSturmschadenText: 'Sturmtief hat ca. 15 ha unseres Kommunalwaldes betroffen. Überwiegend Fichten-Windwurf, teilweise auch entwurzelte Buchen. Wege sind blockiert. Wir brauchen dringend einen Dienstleister für Räumung und Aufarbeitung sowie Beratung zur Wiederbewaldung und möglichen Kalamitätsförderung.',
      bspErholungswaldTitel: 'Naherholungsgebiet aufwerten',
      bspErholungswaldKurz: 'Kommunaler Erholungswald soll attraktiver und sicherer für Besucher werden.',
      bspErholungswaldText: 'Unser 25 ha großes Naherholungsgebiet am Stadtrand wird stark frequentiert (Wanderer, Jogger, Familien). Die Wege sind teilweise in schlechtem Zustand, es fehlt Beschilderung, und einige Bäume entlang der Wege zeigen Trockenheitsschäden. Wir suchen ein Konzept für Wegesanierung, Besucherlenkung und Verkehrssicherung.',
    },
    // Unsicher (Neue Waldbesitzer, Erben)
    unsicher: {
      bspGeerbtTitel: 'Wald geerbt – was nun?',
      bspGeerbtKurz: 'Ohne Vorkenntnisse: Erste Orientierung für einen geerbten Waldbesitz.',
      bspGeerbtText: 'Ich habe Wald geerbt und weiß nicht, was ich damit machen soll. Es sind wohl etwa 8 Hektar in Thüringen, gemischter Bestand. Ich wohne 200 km entfernt und kenne mich mit Forstwirtschaft nicht aus. Gibt es eine Möglichkeit, sich erstmal einen Überblick zu verschaffen?',
      bspZustandTitel: 'Wie steht mein Wald da?',
      bspZustandKurz: 'Allgemeine Zustandsbewertung eines kleinen Privatwaldes gewünscht.',
      bspZustandText: 'Ich habe seit einigen Jahren 5 ha Mischwald, kümmere mich aber kaum darum. Ich möchte wissen: Ist mein Wald gesund? Muss ich etwas tun? Gibt es Schäden, die ich nicht erkenne? Ich hätte gern jemanden, der sich das einmal anschaut und mir eine ehrliche Einschätzung gibt.',
      bspWasWaechstTitel: 'Welche Bäume habe ich?',
      bspWasWaechstKurz: 'Baumarten und Alter im eigenen Wald bestimmen lassen.',
      bspWasWaechstText: 'Ich habe 3 ha Wald in Sachsen-Anhalt und bin mir unsicher, welche Baumarten dort wachsen und wie alt die Bäume sind. Ich erkenne Fichten, aber den Rest nicht. Kann mir jemand helfen, die Baumarten zu bestimmen und zu sagen, ob der Wald so in Ordnung ist?',
      bspWertTitel: 'Was ist mein Wald wert?',
      bspWertKurz: 'Grobe Werteinschätzung des eigenen Waldbesitzes benötigt.',
      bspWertText: 'Ich besitze 12 ha Wald in Hessen und überlege, ob ich ihn verkaufen oder behalten soll. Ich habe keine Ahnung, was Wald pro Hektar wert ist und welche Faktoren den Preis bestimmen. Gibt es eine Möglichkeit, eine grobe Werteinschätzung zu bekommen, bevor ich einen teuren Gutachter beauftrage?',
      bspGrenzenTitel: 'Wo sind meine Waldgrenzen?',
      bspGrenzenKurz: 'Waldgrenzen unklar – Grenzsteine nicht auffindbar, Nachbar hat Bedenken.',
      bspGrenzenText: 'Ich habe eine Waldparzelle von meinem Vater übernommen, aber die genauen Grenzen sind mir unklar. Im Kataster ist die Fläche eingezeichnet, aber im Wald finde ich keine Grenzsteine. Der Nachbar meint, ich würde auf seinem Grund Holz schlagen. Wie kann ich die Grenzen feststellen lassen?',
    },
    // Seiten-Toasts und UI-Texte
    toasts: {
      registrierungErfolg: 'Registrierung erfolgreich!',
      analyseGespeichert: 'Ihre Analyse wurde gespeichert.',
      registrierungFehler: 'Die Registrierung war nicht erfolgreich. Bitte prüfen Sie Ihre Angaben.',
      nachrichtFehler: 'Die Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut.',
      laden: 'Laden...',
      emailBitte: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
      fortschrittWiederhergestellt: 'Fortschritt wiederhergestellt.',
      sammelfallFehler: 'Der Sammelfall konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      entwurfGespeichert: 'Projekt-Entwurf gespeichert!',
      fallSpeichernFehler: 'Der Fall konnte nicht gespeichert werden.',
      auftraegeLadeFehler: 'Die Aufträge konnten nicht geladen werden. Bitte laden Sie die Seite neu.',
      projektNichtGefunden: 'Das Projekt konnte nicht gefunden werden.',
      preisUndBeschreibung: 'Bitte füllen Sie Preis und Beschreibung aus',
      angebotErfolg: 'Angebot erfolgreich abgegeben!',
      angebotFehler: 'Das Angebot konnte nicht abgegeben werden. Bitte versuchen Sie es erneut.',
      angebotAngenommen: 'Angebot angenommen!',
      angebotAnnehmFehler: 'Das Angebot konnte nicht angenommen werden. Bitte versuchen Sie es erneut.',
      wirdGesendet: 'Wird gesendet...',
      angebotAbgeben: 'Angebot abgeben',
      adminLadeFehler: 'Daten konnten nicht geladen werden.',
      adminGeloescht: 'Einträge gelöscht.',
      adminLoeschFehler: 'Einträge konnten nicht gelöscht werden.',
      wirdGeloescht: 'Wird gelöscht...',
      jaAlleLoeschen: 'Ja, alle löschen',
      anbieterLadeFehler: 'Die Anbieter konnten nicht geladen werden.',
      pflichtfelderAusfuellen: 'Bitte füllen Sie alle Pflichtfelder aus',
      projektErfolg: 'Projekt erfolgreich erstellt!',
      projektFehler: 'Das Projekt konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
      wirdErstellt: 'Wird erstellt...',
      projekteLadeFehler: 'Die Projekte konnten nicht geladen werden. Bitte laden Sie die Seite neu.',
      auftragNichtGefunden: 'Der Auftrag konnte nicht gefunden werden.',
      nachrichtHinzufuegen: 'Bitte fügen Sie eine Nachricht hinzu',
      bewerbungErfolg: 'Bewerbung erfolgreich gesendet!',
      bewerbungAngenommen: 'Bewerbung angenommen',
      bewerbungAbgelehnt: 'Bewerbung abgelehnt',
      aenderungFehler: 'Die Änderung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      statusAktualisiert: 'Status aktualisiert',
      willkommen: 'Willkommen bei ForestHub!',
      einstellungenFehler: 'Die Einstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      wirdGespeichert: 'Wird gespeichert...',
      walddatenLadeFehler: 'Ihre Walddaten konnten nicht geladen werden. Bitte laden Sie die Seite neu.',
      waldHinzugefuegt: 'Waldfläche hinzugefügt!',
      walddatenSpeichernFehler: 'Die Walddaten konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.',
      waldGeloescht: 'Waldfläche gelöscht',
      waldLoeschFehler: 'Der Eintrag konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
      auftragVeroeffentlichen: 'Auftrag veröffentlichen',
    },
    placeholders: {
      auswaehlen: 'Auswählen...',
      optional: 'Optional...',
      beschreibungArbeiten: 'Beschreiben Sie die Arbeiten, Besonderheiten des Waldbestandes, Zugänglichkeit, etc.',
      bundeslandAuswaehlen: 'Bundesland auswählen...',
      alleBundeslaender: 'Alle Bundesländer',
      alleKategorien: 'Alle Kategorien',
      auftraegeSuchen: 'Aufträge durchsuchen...',
      alle: 'Alle',
      beschreibungErfahrung: 'Beschreiben Sie Ihre Erfahrung und warum Sie der richtige Partner für diesen Auftrag sind...',
      nachrichtSchreiben: 'Nachricht schreiben...',
      suchen: 'Suchen...',
      projektBeschreiben: 'Beschreiben Sie Ihr Projekt so genau wie möglich...',
      ausMeinemWald: 'Aus "Mein Wald" auswählen',
      waldflaecheAuswaehlen: 'Waldfläche auswählen',
      projekteSuchen: 'Projekte suchen...',
      bundesland: 'Bundesland',
      kategorie: 'Kategorie',
      alleStatus: 'Alle Status',
      alleBaumarten: 'Alle Baumarten',
      angebotBeschreiben: 'Beschreiben Sie Ihr Angebot und Ihre Erfahrung...',
      bundeslandWaehlen: 'Wählen Sie Ihr Bundesland',
      unternehmenBeschreiben: 'Beschreiben Sie Ihr Unternehmen und Ihre Stärken...',
      optionaleNotizen: 'Optionale Notizen zu dieser Fläche...',
      firmaSuchen: 'Firma, Name oder Region suchen...',
      dienstleistung: 'Dienstleistung',
    },
};
